import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function WarningMarkIcon(props: Props) {
  const { t } = useLingui()
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{t`Warning mark Icon`}</title>
      <circle cx="12" cy="12.5" r="9" fill="white" fillOpacity="0.4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 14.5V7.5H11.25V14.5H12.75ZM12.75 17.5V16.5H11.25V17.5H12.75Z"
        fill="white"
      />
    </svg>
  )
}
